import { NodeViewWrapper, type ReactNodeViewProps } from "@tiptap/react";
import { FileIcon } from "lucide-react";

import { Icon } from "simplydo/react/ui/icon";

import type { FileAttrs, FileOptions } from "../extensions/file";

export const FileNodeView = ({
  node,
  editor,
  extension,
}: ReactNodeViewProps) => {
  const { src, name } = node.attrs as FileAttrs;
  const options = extension.options as FileOptions;

  const onClick = () => {
    if (editor.isEditable) {
      return;
    }
    options.onClick?.(src, { src, name });
  };

  return (
    <NodeViewWrapper as="span" data-ext="file" onClick={onClick}>
      <Icon icon={FileIcon} />
      {name}
    </NodeViewWrapper>
  );
};
